import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { ToastProvider } from '../contexts/ToastContext';

/**
 * Scrolls window to top whenever the route/location changes.
 * Rendered inside the router so it has access to useLocation.
 */
function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}

/**
 * Root layout rendered by the router. Wraps all routes with ToastProvider
 * so that toast content (e.g. Link for "View cart") has access to Router context.
 * Also scrolls to top on every navigation (global behavior).
 */
export default function RootLayout() {
  return (
    <ToastProvider>
      <ScrollToTopOnNavigate />
      <Outlet />
    </ToastProvider>
  );
}
